import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import AuthCnt from './components/AuthComponent';
import SignInCnt from './containers/SignInContainer';
import SignUpCnt from './containers/SignUpContainer';
import ForgotPasswordCnt from './containers/ForgotPasswordContainer';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import ForgotPassword from './components/ForgotPassword';
import AuthService from './services/AuthService';
var A6YReactAuth = /** @class */ (function () {
    function A6YReactAuth() {
    }
    A6YReactAuth.prototype.initialize = function (config) {
        globalThis.A6YReactAuthConfig = config;
        new AuthService();
    };
    return A6YReactAuth;
}());
export var Auth = function (_a) {
    var onSuccess = _a.onSuccess, className = _a.className;
    return (React.createElement(AuthCnt, { className: className ? className : undefined, onSuccess: onSuccess ? onSuccess : undefined }));
};
export var SignInContainer = function (_a) {
    var onSuccess = _a.onSuccess, className = _a.className;
    return (React.createElement(SignInCnt, { className: className ? className : undefined, onSuccess: onSuccess ? onSuccess : undefined }));
};
export var SignUpContainer = function (_a) {
    var onSuccess = _a.onSuccess, className = _a.className;
    return (React.createElement(SignUpCnt, { className: className ? className : undefined, onSuccess: onSuccess ? onSuccess : undefined }));
};
export var ForgotPasswordContainer = function (_a) {
    var onSuccess = _a.onSuccess, className = _a.className;
    return (React.createElement(ForgotPasswordCnt, { className: className ? className : undefined, onSuccess: onSuccess ? onSuccess : undefined }));
};
export var SignOut = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, AuthService.signOut()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export { SignIn, SignUp, ForgotPassword };
export default A6YReactAuth;
//# sourceMappingURL=index.js.map